module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('section', {
    staticClass: "left-panel"
  }, [_c('header', [_c('div', {
    staticClass: "grid-container top"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/images/global/logo.svg")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4 vertical-centre"
  }, [_c('div', {
    staticClass: "left-panel-centre"
  }, [_c('h1', [_vm._v("Logging out...")])])])])]), _vm._v(" "), _c('section', {
    staticClass: "hero-image"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83aa9e1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Logout.vue
// module id = 721
// module chunks = 1